export default {
    PROPERTIES: "Свойства"
};
